<template>
  <section>
    <b-field class="is-paddingless is-marginless">
      <b-autocomplete
          ref="autocomplete"
          :value="locationValue"
          :data="sortedFilteredAirports"
          :placeholder="placeholder"
          :field="field"
          :icon="icon"
          :loading="isFetching"
          :keep-first="true"
          :clearable="true"
          @typing="getAsyncData"
          :key="vueKey"
          @input="updateLocation"
          @select="updateLocation"
          @blur="getValueFromInput"
          class="breakWords"
          group-field="type"
          group-options="items"
          :data-test="$props.dataTestAttr"
      >
        <!--
        Values removed from b-autocomplete to fix issue
        where the Flying to / destination field was
        being autofocused on page load.
        Also needed to add a .focus() on mounted to select
        the one field to be focused.
        ===
        @blur="toggleFocus(false)"
        @focus="toggleFocus(true)"
        -->

        <template slot-scope="props">
          <div class="media">
            <div class="media-left" style="left: 0px;">
              <b-tag v-if="props.option.subType == 'AIRPORT'" type="is-info" style="width: 50px">
                {{ props.option.code }}
              </b-tag>
              <b-tag v-if="props.option.subType == 'CITY'" type="is-warning" style="width: 50px">
                {{ props.option.code }}
              </b-tag>
            </div>
            <div class="">
              <p>
                {{ props.option.city }}<span v-if="props.option.state">, {{ props.option.state }}</span>
                <br/>
                <small class="has-text-grey" v-if="props.option.subType == 'AIRPORT'">
                  <span>{{ props.option.airportName }}</span>
                  <span v-if="props.option.countryName">
                    <br>{{ props.option.countryName }}
                  </span>
                </small>
                <small class="has-text-grey" v-if="props.option.subType == 'CITY'">
                  <strong>All Airports</strong>
                  <span v-if="props.option.countryName"><br>{{ props.option.countryName }}</span>
                </small>
              </p>
            </div>
          </div>
        </template>
        <!-- optional -->
        <template #empty>
          <span v-if="data.length === 0 && searchedName.length >= 2">
            No results for: <strong>{{ searchedName }}</strong>
          </span>
        </template>
      </b-autocomplete>
    </b-field>
    <template v-if="fieldLabel || homeAirport">
      {{ fieldLabel }}
      <a v-if="homeAirport" @click="useHomeAirport" class="is-size-7">
        Use home airport - {{ homeAirport }}
      </a>
    </template>
    <template v-if="error" class="mt-2">
      <article class="message is-danger">
        <div class="message-body is-size-7">
          <strong>{{ error }}</strong>
        </div>
      </article>
    </template>
  
  </section>

  
</template>

<script>
  import {mapState} from "vuex";
  import {firstBy} from "thenby";
  let debounce = require('lodash.debounce');

  export default {
    props: {
      theme: {
        type: String,
      },
      placeholder: {
        type: String,
        default: '',
      },
      value: {
        type: [String, Object],
        default: ""
      },
      icon: {
        type: String
      },
      includeAirports: {
        type: Boolean,
        default: true
      },
      includeCities: {
        type: Boolean,
        default: true
      },
      offerHomeAirport: {
        type: Boolean,
        default: false
      },
      autofocus: {
        type: Boolean,
        default: false
      },
      dataTestAttr:{
        type:String,
        default: ''
      }
    },
    data() {
      return {
        data: [],
        isFetching: false,
        token: '',
        hasFocus: false,
        vueKey: 0,
        error: null,
        searchedName: '',
        field: 'code',
        locationValue: '',
      }
    },
    computed: {
      ...mapState(['bookTravel']),
      homeAirport() {

        if (!this.offerHomeAirport) return null

        var profile = this.$store.getters['travellersAndTrips/getCurrentTravellerProfile']

        return profile.airPreferences.homeAirport
      },
      fieldLabel() {
        return this.theme
      },
      sortedFilteredAirports(){

        let airports = this.data;

        let topResultLabel = 'Top Gant Ranking';
        let secondaryResultsLabel = 'Secondary Ranking';
        let airportData = [];
        let gant300 = [];
        let gant9999 = [];

        // sort data into groups: Top Gant Ranking and Secondary Ranking
        if(airports.length > 0) {

          // TOP Gant Ranking
          gant300 = airports.filter(airport => airport.gantRanking <= 300);
          // Secondary Ranking
          gant9999 = airports.filter(airport => airport.gantRanking > 300);

          // Process Top Gant Ranking Airports
          // Only show city options for airports that have a gantRanking <= 300
          // and only when there are two or more airports in the top 300 for that city code.
          // and only when props indicate that we include cities. E.g. Flight form require cities, but Car form does not  if(this.includeCities){}
          if(gant300.length > 0 && this.includeCities){
            const modifiedList = gant300.reduce((acc, item) => {
              if(!acc[item.cityCode]) acc[item.cityCode]=[item];
              else acc[item.cityCode].push(item);
              return acc;
            }, {});

            let newList = [];
            for(let item in modifiedList) {
              newList.push({
                cityCode: item,
                items: modifiedList[item]
              })
            }

            if(newList.length > 0){
              let cityAirport = {};

              for (let i = 0; i < newList.length; i++) {
                // count number of items in array. We need at least 2 items to create city airport.
                if( Object.keys(newList[i].items).length > 1 ){
                  cityAirport.code = newList[i].cityCode;
                  cityAirport.cityCode = newList[i].cityCode;
                  cityAirport.city = newList[i].items[0].city;
                  cityAirport.state = newList[i].items[0].state;
                  cityAirport.countryName = newList[i].items[0].countryName;
                  cityAirport.country = newList[i].items[0].country;
                  cityAirport.subType = 'CITY';
                  // console.log('cityAirport', cityAirport);
                  gant300.unshift(cityAirport);
                }
              }
            }
          }

          // Perform final sort (may be different for Top Gant 300 vs Secondary)
          if(gant300.length > 0 || gant9999.length > 0){
            if(gant300.length > 0){
              gant300.sort((a, b)=> {
                if (a.country === b.country){
                  return a.state < b.state ? -1 : 1
                } else {
                    if(a.country === 'US') return -1;
                    else if(b.country === 'CA') return 1;
                    else return a.country - b.country;
                }
              }); // And then results will be ranked by Gant Ranking (this comes be default from HL api, so we can skip it here)

            }

            if(gant9999.length > 0){
              gant9999.sort((a, b)=> {
                if (a.country === b.country){
                  return a.state < b.state ? -1 : 1
                } else {
                  if(a.country === 'US') return -1;
                  else if(b.country === 'CA') return 1;
                  else return a.country - b.country;
                }
              });
            }
          }

          // Create final Data to pass to Autocomplete component
          if(gant300.length > 0 && gant9999.length > 0){
            airportData.push({
              type: '',
              items: gant300,
            });
            airportData.push({
              type: '',
              items: gant9999,
            });
          }
          else{
            airportData.push({
              type: '',
              items: gant300.length > 0 ? gant300 : gant9999,
            });
          }
        }

        return airportData;
      },
    },
    methods: {
      refreshAuto() {
        this.vueKey += 1;
      },
      getAsyncData: debounce(async function (name) {

        this.isFetching = true;

        // Trim spaces from the beginning and end of the string?
        name = name.trim();

        if (!name.length) {
          this.data = [];
          this.isFetching = false;
          this.searchedName = '';
          return;
        }

        if (name.length > 1) {
          this.searchedName = name;

  
          let foundAirports = this.bookTravel.airports.filter( airport => airport?.detailedName?.toUpperCase().includes(this.searchedName.toUpperCase()) );
          this.data = foundAirports;
          this.isFetching = false;
        }
      }, 150),
      setUp() {
        this.$refs.autocomplete.focus();
      },

      updateLocation(option) {
       // console.log('updateLocation()', option);
       this.locationValue = option;

        this.error = null;

        if(option) {
          if (option === '') {
            option = {
              'name': '',
              'locType': ''
            }
          }
          if (typeof option === 'object' && Object.keys(option).length !== 0) {

            let name  = option.airportName !== '' || option.city !== '';
            if (name !== '' && !option.airportAdded) {
              name = `${name} (${option.code})`;
              option.airportAdded = true;
            }
            option.altered = true;
            // // console.log(option)

            if(option.subType === 'CITY') {
              this.field = 'cityCode';
              this.locationValue = option.cityCode;
            }
            else{
              this.field = 'code';
              this.locationValue = option.code;
            }

            if (name !== '') {
              this.$emit('locUpdate', option);
            }
          }
        }
        else{
          this.$emit('locUpdate', '');
        }
      },

      useHomeAirport() {
        this.$refs.autocomplete.setSelected(this.homeAirport);
        let location = this.$helpers.findAirportByCode(this.homeAirport);
        // console.log('location', location);
        if(location){
          this.$emit('locUpdate', location);
        }
      },
      getValueFromInput(){
        if(this.locationValue && this.locationValue.length > 2) {

          let location = this.$helpers.findAirportByCode(this.locationValue);
          if(location){
            this.$emit('locUpdate', location);
          }
        }
      }
    },
    mounted(){
      //this.$refs.autocomplete.setSelected(this.value);
      if (this.autofocus) {
        this.$refs.autocomplete.focus();
      }
      
    },
    watch: {
      //using a watcher to manually update local component value whenever prop value changes
      value(){
        this.updateLocation(this.value);
      }
    }
}
</script>
